import { useEffect, useState } from "react";

// import { THINKFIC_BASE_URL } from "../../../../apiConfigs/urlConfig";
import bfiles from "../../../../assets/images/files.svg";
import whitefiles from "../../../../assets/images/whitefiles.svg";
import { PrimaryTextButton } from "../../../../shared/Buttons/Buttons";
import {
  enrollToThinkificCourse2,
  loginToThinkificAndRedirect,
} from "../../../../store/features/Thinkific/ThikificApi";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import { roles } from "../../../../helpers/utils/Constants/roles";
import { hasAnyFreeRole, isSelfPacedRole } from "../../../../helpers/utils/roleUtils";

const EmptyProgressCard = (props: any) => {
  const [slug, setSlug] = useState("");
  const dispatch = useAppDispatch();

  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const thinkificState: any = useAppSelector((store: RootStore) => {
    return store.ThinkificSlice;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });

  const startLearning = (slug: string, courseId: number) => {
    setSlug(slug);
    dispatch(enrollToThinkificCourse2({ courseId: courseId })).then((res) => {
      dispatch(
        loginToThinkificAndRedirect({
          slug: slug,
        })
      ).then((res: any) => {
        if (res.payload) {
          console.log(res.payload.url);
          window.open(res.payload.url, "_blank");
        }
      });
    });
  };
  return (
    <div className="empty__section__in__progress">
      <img
        src={themeState.themeMode === "light" ? whitefiles : bfiles}
        alt="fiels"
        className="files"
      />
      <p className="empty__description"> You have not started a course.</p>
      {!(
        isSelfPacedRole(authState?.tac_user?.role,authState)  || hasAnyFreeRole(authState?.tac_user?.all_roles)
      ) && (
        <PrimaryTextButton
          type="button"
          text="Start now"
          loading={thinkificState.loading2}
          nounderline
          onClick={() => startLearning("onboarding", 2066635)}
        />
      )}
      {authState?.tac_user?.role ===
        roles.SELF_PACED_PRODUCT_MANAGER_STUDENT && (
        <PrimaryTextButton
          type="button"
          text="Start now"
          loading={thinkificState.loading2}
          nounderline
          onClick={() =>
            startLearning("product-manager-self-paced-onboarding", 2818425)
          }
        />
      )}
      {authState?.tac_user?.role === roles.SELF_PACED_SCRUM_MASTER_STUDENT && (
        <PrimaryTextButton
          type="button"
          text="Start now"
          loading={thinkificState.loading2}
          nounderline
          onClick={() =>
            startLearning("scrum-master-self-paced-onboarding", 1980675)
          }
        />
      )}
      {authState?.tac_user?.role === roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT && (
        <PrimaryTextButton
          type="button"
          text="Start now"
          loading={thinkificState.loading2}
          nounderline
          onClick={() =>
            startLearning("agile-project-manager-self-paced-onboarding", 1980675)
          }
        />
      )}
    </div>
  );
};

export default EmptyProgressCard;
